import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CsIconModule } from '@components/icon';
import { AovSaleComponent } from './aov-sale.component';
import { LottieComponent } from 'ngx-lottie';

@NgModule({
  imports: [
    CommonModule,
    CsIconModule,
    LottieComponent,
  ],
  declarations: [AovSaleComponent],
  exports: [AovSaleComponent],
})
export class AovSaleModule {}
